import indispensables from '../assets/images/indispensables.webp';
import FriendlyMedia from '../assets/videos/video1.mp4';
    
const FriendlyFaces_indispensables_data = [

    {friendlyFacesData:
        {
            media: FriendlyMedia,
            title: 'For friendly faces',
            desc: 'Selections of cherished skin care—some for the novice with empty bathroom cabinets, others for the well-stocked expert.',
            actionText: 'Browse Skin Care Gifts'
        }
    },
    {
        IndispensablesData:{
            media: indispensables,
            title: 'Portable indispensables',
            desc: 'These skin, hair and body care formulations are suitably sized to refresh frequent travellers en route and at destination.',
            actionText: 'Browse Gifts For Travel'
        }
    }
    
    
]

export default FriendlyFaces_indispensables_data;